import React from 'react';
import enhance from './enhance';
import Select from 'react-select';

export const PriorityDropdown = ({
  disabled,
  onPriorityChange,
  priorityOptions,
  priorityValue,
  quantityZero,
}) => (
  <Select
    disabled={disabled || quantityZero}
    clearable={false}
    value={priorityValue}
    style={{ borderRadius: 0 }}
    onChange={onPriorityChange}
    options={priorityOptions}
    menuStyle={{ backgroundColor: '#E9E9EE' }}
  />
);

export default enhance(PriorityDropdown);
